import {addLocaleData} from 'react-intl';
import load from 'load-script';
import clientLogger, {LOG_ERROR} from './client-logger';

const LANGUAGE_FALLBACKS = {
    'no-NO': 'nb-NO',
    no: 'nb'
};

// react-intl and google maps expect a different locale format from the standard
// ex. "en-US" or "en"
// "no" locale is not valid language, we have to use "nb" instead
export const formatLocale = (locale) => {
    const langCountryPair = locale.match(/^.{2}_.{2}/);
    let formattedLocale = locale.slice(0, 2);

    if (langCountryPair) {
        formattedLocale = langCountryPair[0].replace('_', '-');
    }

    return LANGUAGE_FALLBACKS[formattedLocale] || formattedLocale;
};

// returns correct language from locale
export const getLanguageFromLocale = (locale) => {
    return formatLocale(locale).split(/_|-/)[0];
};


const loadLocaleData = (locale, cb = () => {}) => {
    const language = getLanguageFromLocale(locale);
    if (typeof window === 'undefined') {
        // server side case
        addLocaleData(require(`react-intl/locale-data/${language}`));
        return cb();
    } else if (window.ReactIntlLocaleData[language]) {
        // In the browser, we cheat and use a global. Yay globals!
        addLocaleData(window.ReactIntlLocaleData[language]);
        return cb();
    }

    return load(`${window.reactIntlLocaleDataPath}/${language}.js`, (err) => {
        if (err) {
            clientLogger.captureMessage(
                `loadLocaleData dynamic load failed err=${err}`,
                LOG_ERROR
            );
            return cb(err);
        }
        addLocaleData(window.ReactIntlLocaleData[language]);
        return cb();
    });
};

export default loadLocaleData;



// WEBPACK FOOTER //
// ./src/universal/utils/loadLocale.js